import { Sequences } from '@/utils/permissions'
import { toLocaleDateTimeString } from '@/mixins/convertion'

export function data() {
  return {
    filters: { toLocaleDateTimeString },
    Sequences,
  }
}
